import {
  splitBodyOnMentions,
  type MentionNames,
} from "@hightouch/lib/llm/asset-comments/mention-tokens";

/** A run as the renderer draws it — the target is already resolved to a name. */
type Segment = { text: string; isMention: boolean };

/**
 * The display split: mentions as the `@Name` they render as.
 *
 * The split itself belongs to the backend module that owns the token format,
 * and the mention email renders the same bodies through it — the two
 * disagreeing about what counts as a mention shows up as one surface styling a
 * span the other leaves as prose.
 */
export function splitOnMentions(body: string, names: MentionNames): Segment[] {
  return splitBodyOnMentions(body, names).map((segment) =>
    segment.kind === "mention"
      ? { text: `@${segment.label}`, isMention: true }
      : { text: segment.text, isMention: false },
  );
}
